/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The TaskSearch model module.
 * @module model/TaskSearch
 * @version 1.0.0
 */
export default class TaskSearch {
  /**
   * Constructs a new <code>TaskSearch</code>.
   * @alias module:model/TaskSearch
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>TaskSearch</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TaskSearch} obj Optional instance to populate.
   * @return {module:model/TaskSearch} The populated <code>TaskSearch</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TaskSearch()

      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], ['String'])
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String')
      }
      if (data.hasOwnProperty('room_ids')) {
        obj['room_ids'] = ApiClient.convertToType(data['room_ids'], ['Number'])
      }
    }
    return obj
  }

  /**
   * @member {Array.<module:model/TaskSearch.StatusEnum>} status
   */
  status = undefined
  /**
   * @member {String} title
   */
  title = undefined
  /**
   * @member {Array.<Number>} room_ids
   */
  room_ids = undefined

  /**
   * Allowed values for the <code>status</code> property.
   * @enum {String}
   * @readonly
   */
  static StatusEnum = {
    /**
     * value: "open"
     * @const
     */
    open: 'open',

    /**
     * value: "closed"
     * @const
     */
    closed: 'closed'
  }
}
